export enum CtrlMessageType {
  ERROR = 'ERROR'
}
